export default __webpack_public_path__ + "static/media/ic_montenegro.83a2bec5.svg";